import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import ClientesLista from "./pages/clientes/ClientesLista";
import FuncionariosLista from "./pages/funcionarios/FuncionariosLista";
import Configuracoes from "./pages/configuracoes/Configuracoes";
import ProdutosLista from "./pages/produtos/ProdutosLista";
import ComprasPage from "./pages/compras/Compras";
import VendasPage from "./pages/vendas/Vendas";
import ServicosPage from "./pages/servicos/Servicos";
import FinanceiroPage from "./pages/financeiro/Financeiro";
import DashboardPage from "./pages/dashboard/Dashboard";
import Login from "./pages/login/Login";
import { isAuthenticated } from "./services/auth";
import "./styles/global.css";

function RotaProtegida({ children }) {
  if (!isAuthenticated()) return <Navigate to="/login" replace />;
  return children;
}

function Layout({ children }) {
  return (
    <div className="erp-layout">
      <Sidebar />
      <main className="erp-main">{children}</main>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/*" element={
          <RotaProtegida>
            <Layout>
              <Routes>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/clientes" element={<ClientesLista />} />
                <Route path="/produtos" element={<ProdutosLista />} />
                <Route path="/funcionarios" element={<FuncionariosLista />} />
                <Route path="/vendas" element={<VendasPage />} />
                <Route path="/servicos" element={<ServicosPage />} />
                <Route path="/compras" element={<ComprasPage />} />
                <Route path="/financeiro" element={<FinanceiroPage />} />
                <Route path="/configuracoes" element={<Configuracoes />} />
              </Routes>
            </Layout>
          </RotaProtegida>
        } />
      </Routes>
    </BrowserRouter>
  );
}